import React, { useState } from "react";
import Icon1 from "../icons/Icon";

const Collapsible = ({
  title,
  children,
  defaultOpen = false,
  visible = true,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={` mr-2 ${isOpen ? "mb-2" : ""} ${visible ? "" : "hidden"}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full pl-2 pr-4 mt-1 py-4 h-6 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition"
      >
        <span className="text-h3 mr-2 text-shadow_50 font-medium">{title}</span>
        {isOpen ? (
          <Icon1 icon_name="up" size={15} />
        ) : (
          <Icon1 icon_name="down" size={15} />
        )}
      </button>

      {isOpen && <div className=" ">{children}</div>}
    </div>
  );
};

export default Collapsible;
